module.exports = __webpack_public_path__ + "public/img/project.2345c5e0.png";